// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App'
import router from './router'
import vueCalendar from 'vue2-simple-calendar'
import Trip from './components/Trip'

import "babel-polyfill";

require('es6-object-assign').polyfill();
//require('es6-symbol/implement');

Vue.config.productionTip = false
Vue.config.debug = true
Vue.config.devtools = true

Vue.use(vueCalendar, {
  firstDay: 0,
  locale: 'en',
  fullMonthNames: true
})
Vue.use(VueAxios, axios)

Vue.component('trip', Trip);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js